// Allega il login Supabase (Bearer) a ogni chiamata al backend: le rotte della dashboard lo richiedono.
// Il token arriva dagli eventi di auth (mai getSession() dentro fetch: bloccherebbe il lock di Supabase).
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
let accessToken = null;
let markReady;
const ready = new Promise((resolve) => { markReady = resolve; });

const isBackend = (url) => typeof url === 'string' && API_URL && url.startsWith(`${API_URL}/api/`);

const bearer = async () => {
  await Promise.race([ready, new Promise((r) => setTimeout(r, 3000))]);
  return accessToken ? `Bearer ${accessToken}` : null;
};

export const installAuthHeaders = (supabase) => {
  if (typeof window === 'undefined' || window.__curacheckAuthFetch) return;
  window.__curacheckAuthFetch = true;

  supabase.auth.onAuthStateChange((_event, session) => {
    accessToken = session?.access_token || null;
    markReady();
  });

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url;
    if (!isBackend(url)) return originalFetch(input, init);
    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    if (!headers.has('Authorization')) {
      const auth = await bearer();
      if (auth) headers.set('Authorization', auth);
    }
    return originalFetch(input, { ...init, headers });
  };

  axios.interceptors.request.use(async (config) => {
    if (isBackend(config.url) && !config.headers?.Authorization) {
      const auth = await bearer();
      if (auth) config.headers = { ...config.headers, Authorization: auth };
    }
    return config;
  });
};
